import React from 'react'
import styled, { css } from 'styled-components'
import AddIcon from '@mui/icons-material/Add';
import CompareIcon from '@mui/icons-material/Compare';
import SimulateIcon from '../../src/assets/icons/Simulate.png'
import ComparisonIcon from '../../src/assets/icons/ComparisonIcon.png'
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import CheckIcon from '@mui/icons-material/Check';
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Pitch from '../../src/assets/icons/DarkPitch.png';
import LabelText from './LabelText';
// import { Button } from '../styled-components/SecondaryButtonStyled'

export const StyledButton = styled.button<{ selected?: boolean }>`
    height: fit-content;
    display: flex;
    padding: 8px 16px 8px 12px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    border: 1px solid var(--Shades-Brand-Green-1-green-1-600, #00BE99);
    background: var(--Brand-green-1-500, #00D1A8);
    cursor: pointer;

     ${(props) =>
        props.selected &&
        css`
            border: 1px solid var(--Shades-UI-Blue-blue-600, #0093CF);
            background: var(--Shades-UI-Blue-blue-500, #00A1E4);
        `}

    &:hover {
        border: 1px solid var(--Shades-Brand-Green-1-green-1-700, #009477);
    }
    &:disabled {
        border: 1px solid var(--Shades-Brand-Green-1-green-1-300, #54E0C5);
        background: var(--Shades-Brand-Green-1-green-1-200, #8AEAD7);
        cursor: not-allowed;
        color:#009477;
    }

`;

interface PrimaryButtonProps {
    label?: string;
    iconType?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
    disabled?: boolean;
    selected?: boolean;
}

const iconMap: { [key: string]: JSX.Element } = {
    add: <AddIcon className='secondary-cta-icon' />,
    compare: <img src={ComparisonIcon} className='secondary-cta-icon' alt='ComparisonIcon' />,
    simulate: <img src={SimulateIcon} className='secondary-cta-icon' alt='SimulateIcon' />,
    bookmark: <BookmarkBorderOutlinedIcon className='secondary-cta-icon' />,
    share: <ShareOutlinedIcon className='secondary-cta-icon' />,
    search: <SearchIcon className='secondary-cta-icon' />,
    refresh: <RefreshIcon className='secondary-cta-icon' />,
    confirm: <CheckIcon className='secondary-cta-icon' />,
    playarrow: <PlayArrowIcon className="secondary-cta-icon" />,
    pitch: <img src={Pitch} className='secondary-cta-icon' alt='PitchIcon' />,
};

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
    label, iconType, onClick, className, disabled, selected }) => {
    const icon = iconType ? iconMap[iconType.toLowerCase()] : null;

    return (
        <StyledButton onClick={onClick} className={className} disabled={disabled} selected={selected}>
            {icon}
            {label && <LabelText className= {disabled ? 'primary-disabled-text' :'primary-cta-text'} >{label}</LabelText>}
        </StyledButton>
    );
}

export default PrimaryButton;